import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/Home.vue'
import News from '@/views/News.vue'
import NewsDetail from '@/views/NewsDetail.vue'
import About from '@/views/About.vue'
import Contact from '@/views/Contact.vue'
import Project from '../views/Project.vue'
import Qualification from '../views/Qualification.vue'
import ProjectDetail from '../views/ProjectDetail.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'Home', component: Home, meta: { title: '海南鼎昂建筑工程有限公司' } },
    { path: '/news', name: 'News', component: News, meta: { title: '新闻动态 - 海南鼎昂建筑工程有限公司' } },
    { path: '/news/:id', name: 'NewsDetail', component: NewsDetail, props: true, meta: { title: '新闻详情 - 海南鼎昂建筑工程有限公司' } },
    { path: '/about', name: 'About', component: About, meta: { title: '公司介绍 - 海南鼎昂建筑工程有限公司' } },
    { path: '/contact', name: 'Contact', component: Contact, meta: { title: '联系我们 - 海南鼎昂建筑工程有限公司' } },
    { path: '/project', name: 'Project', component: Project, meta: { title: '工程案例 - 海南鼎昂建筑工程有限公司' } },
    { path: '/project/:id', name: 'ProjectDetail', component: ProjectDetail, meta: { title: '项目详情 - 海南鼎昂建筑工程有限公司' } },
    { path: '/qualification', name: 'Qualification', component: Qualification, meta: { title: '企业资质 - 海南鼎昂建筑工程有限公司' } }
  ]
})